import { postReportReview } from "../services/pgoApi.js";

export const complaintFormHandler = () => ({
    form: { name: '', emailAddress: '', message: '', reviewId: '', declareCheck: false },
    isSubmitted: false,
    loading: false,

    /**
     * Dynamically set the reviewId when the form receives the event.
     */
    setReviewId(reviewId) {
        this.form.reviewId = reviewId;
    },

    /**
     * Submit the form and handle success or error.
     */
    async submitForm() {
        const { name, emailAddress, message, declareCheck, reviewId } = this.form;
        
        // required fields
        const emptyFields = ['name', 'emailAddress', 'message', 'declareCheck']
            .filter(field => !this.form[field]);
    
        if (emptyFields.length) {
            return console.error('Empty fields:', emptyFields);
        }
    
        if (!reviewId) {
            return console.error('Cannot find the review Uuid', reviewId);
        }
    
        const formData = new FormData();
        Object.entries({ name, emailAddress, message, declareCheck, reviewId })
            .forEach(([key, value]) => formData.append(key, value));
    
        try {
            this.loading = true;
            const response = await postReportReview(this.getpgoId(), reviewId, formData);
            if (response) {
                this.isSubmitted = true;
                this.resetForm();
            }
        } catch (error) {
            console.error("Error submitting complaint:", error);
        } finally {
            this.loading = false;
        }
    },    

    /**
     * Resets the form fields.
     */
    resetForm() {
        this.form = { name: '', emailAddress: '', message: '', reviewId: '', declareCheck: false };
    },

     getpgoId() {
        return document.querySelector('[data-pgo-id]')?.dataset.pgoId;
    }
});
